<template>
  <div class="report-calendar">
    <div class="vx-card p-6">
      <label class="text-title">{{ $t('exportFile.newReport') }}</label>
      <div class="vx-row">
        <div class="vx-col md:w-1/3 w-full mt-2 p-4">
          <div class="w-full p-4 pr-8" style="background: rgba(235, 235, 235, .25);height: 510px;">
              <div class="name-report">
                <div class="vx-row">
                  <label class=" text-cake ml-4">{{ $t('exportFile.nameReport') }}</label>
                  <p class="ml-2 text-font " style="color: rgba(var(--vs-danger), 1)">*</p>
                </div>
                <div class="">
                  <vs-input
                    class="mt-2 w-full"
                    :placeholder="$t('exportFile.place')"
                    v-validate="'required'"
                    data-vv-validate-on="blur"
                    type="text"
                    v-model="fileName"
                  ></vs-input>
                </div>
              </div>
              <div class="type-report mt-6">
                <div class="vx-row">
                  <label class=" text-cake ml-4">{{ $t('exportFile.typeReport') }}</label>
                  <p class="ml-2 text-font " style="color: rgba(var(--vs-danger), 1)">*</p>
                </div>
                <div class="select-type">
                  <v-select
                    class=" mt-2 w-full"
                    icon="AlertCircleIcon"
                    :options="optionalTime"
                    v-model="rangeTimeSelected"></v-select>
                </div>
              </div>
          </div>
        </div>

        <div class="vx-col md:w-2/3 w-full mt-2 p-4">
          <div class="vx-row m-0">
            <label class="text-cake">{{ $t('exportFile.contentReport') }}</label>
            <feather-icon
              icon="HelpCircleIcon"
              class="ml-2 icon-help"
            >
            </feather-icon>
          </div>
          <div class="w-full p-4 pr-8 mt-2" style="background: rgba(235, 235, 235, .25)">
            <div class="vx-row">
              <div class="vx-col md:w-1/2 w-full">
                <label class="text-cake">{{ $t('exportFile.topic') }}</label>
                  <v-select
                    class="mt-2 w-full"
                    icon="AlertCircleIcon"
                    v-model="valueSelected"
                    :options="optionalTopics"
                    multiple>
                  </v-select>
              </div>
<!--              <div class="vx-col md:w-1/2">-->
<!--                <label class="text-cake">{{ $t('exportFile.topic') }}</label>-->
<!--                  <v-select-->
<!--                    class="mt-2 w-full"-->
<!--                    icon="AlertCircleIcon"-->
<!--                    v-model="valueSelected"-->
<!--                    :options="optionalTopics"-->
<!--                    multiple>-->
<!--                  </v-select>-->
<!--              </div>-->
            </div>

            <div class="vx-row mt-4">
                <div class="vx-col w-full">
                  <label class="text-cake">{{ $t('exportFile.dataRange') }}</label>
                  <feather-icon
                    icon="HelpCircleIcon"
                    class="ml-2 icon-help"
                  ></feather-icon>
                </div>
                <div class="vx-col w-full mt-2">
                  <date-range-picker
                    ref="picker"
                    :locale-data="{format: 'dd/mm/yyyy' }"
                    :opens="'left'"
                    @update="initScreen"
                    v-model="dateRange"
                    class="boder-date-ranpicker"
                  >
                  </date-range-picker>
                </div>
            </div>

            <div class="vx-row">
              <div class="vx-col mt-4 md:w-1/2 w-full">
                <div class="vx-row">
                  <label class="ml-4 text-cake">{{ $t('exportFile.source') }}</label>
                </div>
                <v-select
                  class="mt-2 w-full"
                  icon="AlertCircleIcon"
                  v-model="valueSelectedArticle"
                  :options="optionalArticle"
                  multiple>
                  </v-select>
              </div>
            </div>

            <div class="vx-row">
              <div class="vx-col w-full">
                <div class="vx-row ml-0 mt-4">
                  <label class="text-cake">{{ $t('exportFile.contentConfiguration') }}: </label>
                  <!-- <p class="ml-2 text-font " style="color: rgba(var(--vs-danger), 1)">*</p> -->
                </div>
              </div>
              <div class="vx-col mt-8 w-full">
                <div class="vx-row">
                  <div class="vx-col md:w-2/12 w-full">
                    <label class="ml-0 text-cake mt-2">{{ $t('exportFile.sendTo') }} :</label>
                  </div>
                  <div class="vx-col md:w-10/12 ti-input w-full">
                    <vue-tags-input
                      placeholder=""
                     v-model="sendTo"
                      :tags="tagSendTos"
                      allow-edit-tags
                      @tags-changed ="newTags => tagSendTos = newTags"
                    />
                  </div>
                </div>
                <div class="vx-row mt-8">
                  <div class="vx-col md:w-2/12 w-full">
                    <label class="ml-0 text-cake mt-2">CC :</label>
                  </div>
                  <div class="vx-col md:w-10/12 ti-input w-full">
                    <vue-tags-input
                      placeholder=""
                      v-model="sendCC"
                      :tags="tagCCs"
                      allow-edit-tags
                      @tags-changed ="newTags => tagCCs = newTags"
                    />
                  </div>
                </div>
                <div class="vx-row mt-8">
                  <div class="vx-col md:w-2/12 w-full">
                    <div class="vx-row ml-0">
                      <label class="ml-0 text-cake mt-2">{{ $t('exportFile.title') }} :</label>
                      <!-- <p class="ml-2 text-font " style="color: rgba(var(--vs-danger), 1)">*</p> -->
                    </div>
                  </div>
                  <div class="vx-col md:w-10/12 w-full ti-input">
                    <vs-input v-model="title" class="w-full"></vs-input>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="mt-4 mb-4 flex flex-wrap items-center justify-end">
            <vs-button class="ml-auto mt-2 text-size" type="border" @click="$router.go(-1)">
              {{ $t('exportFile.cancel') }}
            </vs-button>
            <vs-button class="ml-4 mt-2 text-size" @click="exportFile">{{ $t('exportFile.exportFile') }}
            </vs-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import DateRangePicker from '@/layouts/components/vue2-daterange-picker/components/DateRangePicker.vue'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import authConfig from '@/../auth_config.json';
import VueTagsInput from '@johmun/vue-tags-input';
import {quillEditor} from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import moment from "moment";

export default {
  components: {
    DateRangePicker,
    vSelect,
    VueTagsInput,
    quillEditor

  },
  data() {
    return {
      sendTo: '',
      sendCC: '',
      tagSendTos:[],
      tagCCs: [],
      title: null,
      fileName: null,
      optionGroupTopics:[],
      valueSelected: [],
      originTopic :[],
      projectSelected: [],
      valueSelectedArticle: [],
      optionalTopics: [],
      optionalArticle: [
        {label: this.$t('exportFile.postFb'), value: 104},
        {label: this.$t('exportFile.commentFb'), value: 105},
        {label: this.$t('exportFile.news'), value: 101},
        {label: 'Youtube', value: 106},
        {label: 'Forum', value: 111},
        {label: 'Google', value: 113},
        // {label : 'Tiktok', value : 116},
        // {label : 'Tiktok Trending', value : 117},
        {label : 'Twitter', value : 118},
        {label : 'Instagram', value : 119},
      ],
      optionalTime: [
        {label: this.$t('exportFile.brandHealthByDay'), value: 0},
        {label: this.$t('exportFile.brandHealthByWeek'), value: 1}
      ],
      dateRange: {
        endDate: new Date(),
        startDate: (() => {
          let date = new Date();
          date.setDate(date.getDate() - 6);
          date.setHours(0, 0, 0);
          return date
        })()
      },
      valueOption: null,
      createBy: null,
      responseFileName: null
    }
  },
  computed: {
    rangeTimeSelected: {
      get() {
        let object = this.optionalTime.find(el => this.valueOption === el.value);
        if (!object) {
          return {};
        }
        return {
          label: object.label,
          value: this.valueOption
        }
      },
      set(object) {
        this.valueOption = object ? object.value : null;
      }
    }
  },
  methods: {
    getTopics: function () {
      this.$business.post('topic/find-by-conditions', {}).then((response) => {
        this.optionalTopics = response.data.map(el => {
          return {
            label: el.topicName,
            value: el.id,
            createBy: el.content
          }
        })
      })
    },
    getTopicGroups: function(){
      return new Promise((resolve,reject) =>{
        this.$business.post('/topic-group/find-by-conditions',{}).then((res) =>{
          this.optionGroupTopics= res.data;
          if(this.optionGroupTopics.length > 0){
            this.optionGroupTopics = this.optionGroupTopics.map(el =>{
              if(el.groupName && el.groupName.length > 25){
                el.groupName = el.groupName.slice(0,25) + '...';
              }
              return {
                label:el.groupName,
                value:el.id
              }
            })
            if (this.groupName) {
              let selectedItem = this.optionGroupTopics.find(item => item.value == this.groupName)
              if (selectedItem) this.optionGroupTopics = selectedItem;
            }
            this.optionGroupTopics.unshift({label: this.$t('articleBookmark.all'),
              value: null})
          }
          resolve();
        }).catch(() => reject())
      })
    },
    getTopicByOrganizationBranding: function() {
      const result = this.optionGroupTopics;
      this.$vs.loading();
      const payload = {};
      this.$business
        .post(`topic/find-by-conditions`, payload)
        .then(res => {
          this.$business.post(`share-topic/get-all-share`,{}).then((response) => {
            let currentUserName = JSON.parse(localStorage.userInfo).email
            const dataShare = response.data;
            const dataShareTopic = response.data;
            if(dataShare.status == 0){
              dataShareTopic.forEach(key =>{
                key.status = dataShare.status;
              })
            }
            const data = [...res.data, ...dataShareTopic.filter(item => item.status == 0 || item.status == 1)];
            this.statusShare = response.data.status;
            if (res.status == "200") {
              this.countBranding = this.optionalBranding.length;
              this.countProductBranding = this.optionalProductBranding.length;
              this.countPersonalBranding = this.optionalPersonalBrandig.length;
              this.$vs.loading.close();
              this.responseData = data;
              data.forEach(el => {
                el.currentUserName = currentUserName;
                if(el.keywords.length > 2){
                  el.plus = el.keywords.length - 2;
                  el.keyword = el.keywords.map(k => k.keyword).slice(0,2).join(", ");
                }
                else{
                  el.keyword = el.keywords.map(k => k.keyword).join(", ");
                }
                if(el.topicName.length > 25){
                  el.topicName = el.topicName.slice(0,25) + '...';
                }
                el.createdDate = moment(el.createdDate || el.modifiedDate).format("DD/MM/YYYY");
                el.checked = false;
                if (!this.optionGroupTopics.find(item => item.value == el.topicGroupId)) {
                  el.isOther = true
                } else {
                  el.isOther = false
                }
              });
              this.topics = data;
              const countOther= data.filter(item => item.isOther);
              this.countOther = countOther.length;
            }
            let resultFilter = [];
            let checkedShareId = [];
            result.forEach(el => {
              resultFilter = data.filter(topic => el.value == topic.topicGroupId)
              checkedShareId = resultFilter.filter(filter => !filter.shareId);
              // let resultFilterOther = data.filter(topic => el.value != topic.topicGroupId)
              // let checkedShareOther = resultFilterOther.filter(filter => !filter.shareId);
              if(checkedShareId.length > 0){
                el.checkedAll = true;
              }
              if(el.isOther){
                this.checkedSelected = true;
              }
            })
          })
            .catch(() => {
              return this.$vs.loading.close();
            });
        })
    },
    findByGroup: function (e){
      this.optionalsTopic = this.optionalsTopic.filter(el=>el.topicGroupId == e.value);
    },
    initScreen() {
      this.getTopics();
      this.getTopicGroups().then(() =>{
        this.getTopicByOrganizationBranding()
      })
      this.updateI18n();
      this.checkboxSource();

    },
    updateI18n: function () {
      this.optionalTime[0].label = this.$t('exportFile.brandHealthByDay')
      this.optionalTime[1].label = this.$t('exportFile.brandHealthByWeek')
    },
    checkboxSource: function () {
      this.optionalArticle[0].label = this.$t('exportFile.postFb')
      this.optionalArticle[1].label = this.$t('exportFile.commentFb')
      this.optionalArticle[2].label = this.$t('exportFile.news')
    },
    validateEmail: function(email){
      let strEmail = email.toString();
      const regExp = new RegExp(/^(\s?[^\s,]+@[^\s,]+\.[^\s,]+\s?,)*(\s?[^\s,]+@[^\s,]+\.[^\s,]+)$/);
      const result = regExp.test(strEmail);
      return result;
    },
    exportFile: function () {
      const result = this.valueSelected.map(el => el.value);
      const resultArticle = this.valueSelectedArticle.map(el => el.value);
      if (this.valueOption === null) {
        return this.$vs.notify({
          text: this.$t('exportFile.textReport'),
          icon: 'icon-alert',
          iconPack: 'feahter',
          color: 'danger'
        })
      }
      let sendToEmails = this.tagSendTos.map(el => el.text);
      let ccEmail = this.tagCCs.map(el =>el.text);
      let validEmail = this.validateEmail(sendToEmails);
      let valieEmailCC = this.validateEmail(ccEmail);
      if (sendToEmails.length > 0){
        if (!validEmail) {
          return this.$vs.notify({
            text: this.$t('exportFile.validateEmail'),
            icon: 'icon-alert',
            iconPack: 'feahter',
            color: 'danger'
          })
        }

        if (!validEmail) return;
      }
      if (ccEmail.length >  0) {
        if (!valieEmailCC) {
          return this.$vs.notify({
            text: this.$t('exportFile.validateEmail'),
            icon: 'icon-alert',
            iconPack: 'feahter',
            color: 'danger'
          })
        }

        if (!valieEmailCC) return;
      }

      this.$vs.loading();
      if (this.dateRange) {
        const endDate = new Date(this.dateRange.endDate.setHours(23, 59, 59));
        const payload = {
          from: this.dateRange.startDate,
          to: endDate,
          topics: result,
          beanTypes: resultArticle,
          fileName: this.fileName,

        }
        let userInfo = JSON.parse(localStorage.userInfo);
        let url =  "user-data/export-word-top";
        if (userInfo.id == 568) {
          payload.domain = [
            "nhandan.vn",
            "dangcongsan.vn",
            "cand.com.vn",
            "qdnd.vn",
            "doisongphapluat.com",
            "tuoitre.vn",
            "thanhnien.vn",
            "laodong.vn",
            "thanhtra.com.vn",
            "vietnamnet.vn",
            "tienphong.vn",
            "vtv.vn",
            "vov.vn",
            "vnanet.vn"
          ]
          url = "user-data/export-file"
        }
        
        if (this.valueOption == 0) {
          
          this.$report.post(url, payload).then((response) => {
            this.responseFileName = response.data;
            this.sendFileToMailCC();
            window.open(authConfig.reportDomain + "download/" + response.data + "?access_token=" + localStorage.getItem("access_token"), "_blank");
            this.$vs.loading.close();
            if (!response || !response.data) return this.$vs.notify({
              text: this.$t('createReportError'),
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            });
            return this.$vs.notify({
              text: this.$t('exportFile.textSuccess'),
              icon: 'icon-alert',
              iconPack: 'feahter',
              color: 'color'
            })
          })
            .catch((err) => {
              this.$vs.loading.close();
              return this.$vs.notify({
                text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              });
            })
        }
        if (this.valueOption == 1) {
          let userInfo = JSON.parse(localStorage.userInfo);
          if (userInfo.id == 568) {
            payload.domain = [
              "nhandan.vn",
              "dangcongsan.vn",
              "cand.com.vn",
              "qdnd.vn",
              "doisongphapluat.com",
              "tuoitre.vn",
              "thanhnien.vn",
              "laodong.vn",
              "thanhtra.com.vn",
              "vietnamnet.vn",
              "tienphong.vn",
              "vtv.vn",
              "vov.vn",
              "vnanet.vn"
            ]
          }
          this.$report.post(`user-data/export-by-project`, payload).then((response) => {
            this.responseFileName = response.data;
            this.sendFileToMailCC();
            window.open(authConfig.reportDomain + "download/" + response.data + "?access_token=" + localStorage.getItem("access_token"), "_blank");
            this.$vs.loading.close();
            return this.$vs.notify({
              text: this.$t('exportFile.textSuccess'),
              icon: 'icon-alert',
              iconPack: 'feahter',
              color: 'color'
            })
          })
            .catch((err) => {
              this.$vs.loading.close();
              return this.$vs.notify({
                text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              });
            })
        }
        if (this.valueOption == 2) {
          this.$report.post(`user-data/export-file-vnPost`, payload).then((response) => {
            this.responseFileName = response.data;
            this.sendFileToMailCC();
            this.$vs.loading.close();
            if (!response || !response.data) return this.$vs.notify({
              text: this.$t('createReportError'),
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            });
            window.open(authConfig.reportDomain + "download/" + response.data + "?access_token=" + localStorage.getItem("access_token"), "_blank");
            this.$vs.loading.close();
            return this.$vs.notify({
              text: this.$t('exportFile.textSuccess'),
              icon: 'icon-alert',
              iconPack: 'feahter',
              color: 'color'
            })
          })
            .catch((err) => {
              this.$vs.loading.close();
              return this.$vs.notify({
                text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              });
            })
        }
      }
    },

    sendFileToMailCC: function(){
      const sendToEmails = this.tagSendTos.map(el => el.text);
      const mailCC = this.tagCCs.map(el => el.text);
      const resultArticle = this.valueSelectedArticle.map(el => el.value);
      let nameDay = '';
      if (this.valueOption == 0) nameDay = "DAY";
      if (this.valueOption == 1) nameDay = "WEEK";
      let userInfo = JSON.parse(localStorage.getItem('userInfo'));
      const payload = [{
        beanTypes: resultArticle,
        ccEmail: mailCC,
        emails: sendToEmails,
        startDate: this.dateRange.startDate,
        endDate: this.dateRange.endDate,
        name: this.responseFileName,
        sendNow: true,
        title: this.title,
        reportType: nameDay,
        startData: this.dateRange.startDate,
        reportTopicList: [],
        fileAttached: true,
        customerType: userInfo.customerType
      }]
      this.$report.post('/report/create', payload).then(() => {

      }).catch((err) => {
        return this.$vs.notify({
          text: err.response.data.message || err.response.data.error_description || err.response.data.error,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });
      })
       
    },
    saveByteArray: function (reportName, byte) {
      var blob = new Blob([byte], {type: "application/xml"});
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      var fileName = reportName;
      link.download = fileName;
      link.click();
    }
  },
  async created() {
    this.dateRange.startDate = new Date(
      this.dateRange.startDate.setHours(0, 0, 0)
    );
    this.dateRange.endDate = new Date(
      this.dateRange.endDate.setHours(23, 59, 59)
    );
    this.initScreen();
    this.$eventBus.$on('i18n', () => {
      this.initScreen();
    });
    let userInfo = JSON.parse(localStorage.userInfo);
    if (userInfo.email.includes("vnpost")) {
      this.optionalTime.push({label: this.$t('exportFile.brandHealthByVNPost'), value: 2})
    }
  }
}


</script>

<style scoped>
.text-title {
  font-size: 16px;
  letter-spacing: 0.44px;
  line-height: 24px;
  font-weight: bold;
  color: rgb(94 88 115);
}

.text-cake {
  font-size: 13px;
  letter-spacing: 0.2px;
  color: rgb(94 88 115);
  font-weight: bold;
}

.text-checkbox {
  font-size: 12px;
  line-height: 22px;
  color: rgb(159 162 180);
}
</style>
<style lang="css">
.vue-daterange-picker .ranges {
  float: right;
  border-left: 1px solid #ddd;
}

.daterangepicker {
  border-left: none !important;
}

.export-file {
  position: absolute;
  right: 2rem;
}

.reportrange-text {
  border-radius: 10px;
  height: 37px;
  line-height: 27px;
}

.title-size {
  font-size: 16px !important;
}

.text-size {
  font-size: 12px !important;
}

.minus-top {
  margin-top: -24px;
}

.selected-topic .vs__selected {
  color: #fff;
  background-color: #5C6BC0;
}

.selected-topic .v-select .vs__dropdown-toggle .vs__deselect svg {
  stroke: #fff;
  opacity: 1;
}

.ti-input {
  border-radius: 5px;
}
.icon-help {
  vertical-align: text-top;
  width: 14px;
  height: 15px;
  color: black;
}
</style>
